<div
  class="filter-sort-bar"
  [ngClass]="{ 'filter-box-opened': !!selectedFilter }">
  <app-horizontal-scroller
    [isBackgroundLight]="true"
    [isSmall]="true"
    [overflowVisible]="true">
    <div class="scroll-wrapper" #scrollWrapper>
      <div class="filters">
        @for (filter of displayedFilters; track $index) {
          <div class="filter">
            <button
              class="filter-btn"
              [ngClass]="{
                active: isFilterActive(filter),
                open: selectedFilter === filter,
              }"
              (click)="onSelectOrUnselectFilter(filter.name)">
              @if (filter.icon) {
                <span [ngClass]="'icon ' + filter.icon"></span>
              }
              <span>{{ filter.label | translate }}</span>
              <span
                class="icon"
                [ngClass]="{
                  'icon-slide-arrow': selectedFilter !== filter,
                  'icon-fleche': selectedFilter === filter,
                }"></span>
              @if (filter.selectedOptions?.length && isFilterActive(filter)) {
                <span class="badge">{{ filter.selectedOptions?.length }}</span>
              }
            </button>
            @if (selectedFilter === filter) {
              <app-filter-box
                [filter]="filter"
                [sport]="selectedSport$ | async"
                [unit]="unit | async"
                (closeBox)="onSelectOrUnselectFilter(filter.name)"
                (applyFilter)="onApplyFilter(filter.name, $event)" />
            }
          </div>
        }
        <div class="filter">
          <button
            class="all-filters-btn"
            [ngClass]="{
              active: areExtraFiltersActive() || numberOfActiveFilters,
            }"
            (click)="onDisplayAllFilters()">
            <span class="icon icon-new-filter"></span>
            @if (numberOfActiveFilters) {
              <span class="badge">{{ numberOfActiveFilters }}</span>
            }
          </button>
        </div>
      </div>
      <div class="sorts">
        <kin-icon
          name="sort"
          size="16"
          [class.asc]="sortDirection !== 'desc'"
          (click)="toggleSortDirection()" />
        <span class="sort-by">
          {{ 'browse.filterSort.sorts.sortBy' | translate }}
        </span>
        <div
          ngbDropdown
          placement="bottom-right"
          id="browseSelectSortingContainer">
          <button ngbDropdownToggle type="button" id="browseSelectSorting">
            <span>
              {{ getSelectedSortingLabel(selectedSorting.label | translate) }}
            </span>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="browseSelectSorting"
            class="browse-sort-options">
            @for (sorting of availableSortings; track $index) {
              <button
                ngbDropdownItem
                (click)="onChangeSorting(sorting.value)"
                class="browse-sort-option"
                [ngClass]="{
                  selected: selectedSorting.value === sorting.value,
                }">
                <input
                  [checked]="selectedSorting.value === sorting.value"
                  type="radio"
                  name="sortBy"
                  [id]="'sortBy-' + sorting.label" />
                <label [for]="'sortBy-' + sorting.label">
                  {{ sorting.label | translate }}
                </label>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </app-horizontal-scroller>
</div>
